import { el } from '../ui/dom';

export function renderConnect(root: HTMLElement): void {
  root.innerHTML = '';
  root.append(
    el('div', { className: 'connect-page' }, [
      el('h1', {}, 'Remindo'),
      el('p', {}, 'Manage devices, members, and voices from your phone after scanning the Web settings QR on your Remindo.'),
      el('div', { className: 'card' }, [
        el('h2', {}, 'Lost connection?'),
        el('p', {}, 'On your Remindo: Settings → Device → Web settings, then scan the QR code with this phone. You do not need to set up Wi‑Fi again.'),
      ]),
      el('p', { className: 'muted' }, 'First-time setup? Complete Scan to connect on your device, then open Web settings.'),
      el('p', { className: 'muted' }, 'Developers: paste token via /dev on the server, then open /?token=...'),
    ]),
  );
}
